<template>
  <div>
    <div class="lx_classbox" v-show="isShow" >
      <div class="clearfix yx_classtitbox bbcolor">
        <h3 class="fl yx_classtit">前途出国</h3>
        <ul class="fl yx_titlist">
          <li
            v-for="(item, index) in qiantu"
            :key="index"
            :class='["fl",index === currQiantuIndex?"yxempty_titliston":""]'
            @click="changeQtItem(index)"
          >
            {{item.cnName}}
          </li>
        </ul>
      </div>
      <ul
        class="yx_qiantubox clearfix"
        v-for="(item, index) in qiantuData"
        :key="index"
        v-show="index === currQiantuIndex"
      >
        <li
          v-for="(eve, eveIndex) in item"
          :key="eveIndex"
          :href="eve.url"
          :class='(eveIndex + 1) % 4 === 0?"mr0":""'
          v-show="index === currQiantuIndex"
        >
          <a :href="eve.churl"><img :src="eve.imageUrl"/></a>
          <a :href="eve.url"><p>{{eve.title}}</p></a>
        </li>
      </ul>
    </div>
    <div class="lx_classbox" v-show="isShow1">
      <div class="clearfix yx_classtitbox bbcolor">
        <h3 class="fl yx_classtit">国际游学</h3>
        <ul class="fl yx_titlist">
          <li
            :class='["fl",index === yxCurrIndex?"yxempty_titliston":""]'
            v-for="(item, index) in youxue"
            :key="index"
            v-show="youxueData[index] && youxueData[index].length >= 5"
            @click="changeYxItem(index)"
          >
            {{item.country}}
          </li>
        </ul>
      </div>
      <ul
        class="yx_youxuebox"
        v-for="(eveYouxue, index) in youxueData"
        v-show="index === yxCurrIndex"
        :key="index"
      >
        <li
          v-for="(item, index) in eveYouxue"
          :key="index"
          :class='[index === eveYouxue.length-1?"mr0":""]'
        >
          <a :href="item.url">
            <img :src="item.thumb_url" >
          </a>
          <a :href="item.url">
            <p class="p_1">{{ item.name }}</p>
          </a>
          <p class="p_2">招生对象 : {{ item.admission_object }}</p>
          <p class="p_2">截止时间 : {{ item.end_sign_day }}</p>
          <p class="p_2">订金 : <span>￥{{ item.market_price }}</span></p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getYouxueData } from 'js/youxue.js'
import { getQiantuData } from 'js/youxue.js'
export default {
  name: 'youxue',
  data () {
    return {
      qiantu: [{
        cnName: '美研',
        enName: 'Master'
      },
      {
        cnName: '美本',
        enName: 'Undergraduate'
      },
      {
        cnName: '美中',
        enName: 'Highschool'
      },
      {
        cnName: '英国',
        enName: 'England'
      },
      {
        cnName: '加拿大',
        enName: 'Canada'
      },
      {
        cnName: '澳大利亚',
        enName: 'Australia'
      },
      {
        cnName: '新西兰',
        enName: 'NewZealand'
      }],
      youxue: [{
        cat_id: 1,
        country: '美国'
      },
      {
        cat_id: 2,
        country: '加拿大'
      },
      {
        cat_id: 3,
        country: '澳洲'
      },
      {
        cat_id: 4,
        country: '英国'
      },
      {
        cat_id: 5,
        country: '香港'
      },
      {
        cat_id: 6,
        country: '新西兰'
      },
      {
        cat_id: 7,
        country: '亚洲'
      },
      {
        cat_id: 8,
        country: '欧洲'
      }],
      qiantuData: new Array(7),
      youxueData: [],
      currQiantuIndex: -1,
      yxCurrIndex: -1
    }
  },
  computed: {
    isShow(){
      let r = [],_this = this, defaulti = -1
      this.qiantuData.forEach((item,index) => {
        if(item.length && item.length >= 5 && defaulti == -1){
          defaulti = index
        }
      })
      _this.currQiantuIndex = defaulti
      return defaulti == -1 ? 0 : 1
    },
    isShow1(){
      let r = [],_this = this, defaulti = -1
      this.youxueData.forEach((item,index) => {
        if(item.length && item.length >= 5 && defaulti == -1){
          defaulti = index
        }
      })
      _this.yxCurrIndex = defaulti
      return defaulti == -1 ? 0 : 1
    }
  },
  methods: {
    getQiantuOnce (i) {
      return getQiantuData(this.qiantu[i].enName)
    },
    getYouxueOnce (index) {
      return getYouxueData(this.youxue[index].cat_id)
    },
    formaterRequest (i, fn ,suc, len) {
      if(i>=len) return false
      fn(i).then(res => {
        suc(res, i)
        i++
        this.formaterRequest(i,fn,suc,len)
      }).catch(rej => {
        i++
        this.formaterRequest(i,fn,suc,len)
      })
    },
    changeYxItem (index) {
      this.yxCurrIndex = index
    },
    changeQtItem (index) {
      this.currQiantuIndex = index
    }
  },
  mounted () {
    let _this = this
    // 加载前途出国
    let qiantuDataInit = []
    this.formaterRequest(0, this.getQiantuOnce, function(res, i){
        if (res.length >= 6) {
          qiantuDataInit[i] = res
        } else {
          qiantuDataInit[i] = []
        }
        if(i == _this.qiantu.length - 1){
          _this.qiantuData = qiantuDataInit
        }
    },_this.qiantu.length)
    // 加载国际游学
    let youxueDataInit = []
    this.formaterRequest(0, this.getYouxueOnce, function(res, i){
        if (res.length >= 5) {
          youxueDataInit[i] = res
        }else {
          youxueDataInit[i] = []
        }
        if(i == _this.youxue.length - 1){
          _this.youxueData = youxueDataInit
        }
    },_this.youxue.length)
  }
}
</script>

<style scoped lang="stylus">
.fl
  display:inline
  float: left
.fr
  display:inline
  float: right
.posR
  position: relative
/*留学游学*/
.mr0
  margin-right: 0!important
.lx_classbox
  width: 1200px
  margin: 40px auto
  .yx_classtitbox
    width: 1200px
    height: 36px
    line-height: 36px
    border-bottom: 2px solid #98dfd2
    .yx_classtit
      width: 194px
      font-size: 20px
      color: #333
      padding-left: 6px
      margin-right: 10px
    .yx_titlist
      li
        height: 36px
        line-height: 36px
        padding: 0 28px
        float: left
        border-left: 1px solid #fff
        border-right: 1px solid #fff
        font-size: 16px
        color: #333
        cursor: pointer
      .yxempty_titliston
        border-left: 1px solid #a5e1d6
        border-right: 1px solid #a5e1d6
        border-top: 2px solid #00b388
        background: #fff
        height: 38px
        line-height: 36px
        margin-top: -2px
        color: #00b388

  .yx_qiantubox
    &:after
      content: ""
      display block
      clear both
    li
      float: left
      margin-right: 13px
      margin-top: 25px
      width: 290px
      height: 236px
      img
        width: 290px
        height: 195px
        display: block

      p
        width: 275px
        height: 44px
        line-height: 42px
        padding-left: 15px
        overflow: hidden
        font-size 16px
        color #333
      &:hover
        box-shadow: 1px 5px 10px 1px #e5e5e5
        p
          // background: #f8f8f8
          color: #333

  .yx_youxuebox
    li
      width: 227px
      height: 290px
      float: left
      margin-right: 16px
      margin-top: 25px
      img
        width: 227px
        height: 153px
      p
        margin-top: 5px
      .p_1
        font-size: 14px
        height: 40px
        line-height: 20px
        overflow: hidden
        color #333
        margin-bottom 7px
        &:hover
          color #00b388
      .p_2
        color: #8d8d8d
        font-size: 12px
        span
          font-size: 16px
          color: #ff7011
</style>



// WEBPACK FOOTER //
// src/pages/gobroad/components/mainfloor/Youxue.vue